import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { Input } from '@progress/kendo-react-inputs';
import VideoPreview, { youtube_parser } from '../../VideoPreview';
import Uploader, { uploaderTypes } from '../../Uploader';
import ListEditor from '../../ListEditor';
import { LocalizationContext } from '../../../contexts';
import PublishSwitch from '../publishSwitch';
import './index.scss';
import '../forms.scss';

export default function VideoBanner({ data, settingsData = {}, onUpdate, validator, ...rest }) {
  const emptyItem = useRef({
    title: "",
    video: "",
    video_poster: "",
    video_poster_mobile: "",
    isPublish: false
  });
  const generalEmptyItem = useRef({ ...emptyItem.current });
  const personalEmptyItem = useRef({ ...emptyItem.current });
  const [compData, setCompData] = useState({});
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;

  validator.current = () => {
    return true;
  };

  useEffect(() => {
    let defaultData = { items: [settingsData.type === "general" ? { ...generalEmptyItem.current } : { ...personalEmptyItem.current }] };
    const startCompData = { ...defaultData, ...JSON.parse(JSON.stringify(data ? data : {})) };
    if (startCompData.items.length === 0) {
      startCompData.items = [settingsData.type === "general" ? { ...generalEmptyItem.current } : { ...personalEmptyItem.current }];
    }
    setCompData(startCompData);
  }, [data]);

  const canPublish = (item) => {
    if (!(item.title && item.video && item.video_poster && item.video_poster_mobile)) {
      return false;
    }
    return true;
  };

  const updateItem = useCallback((i, newData, key) => {
    let newCompData;
    if (i !== null) {
      newCompData = { ...compData };
      if (key) {
        newCompData.items[i][key] = newData;
      }
      else {
        newCompData.items[i] = { ...newCompData.items[i], ...newData };
      }
      newCompData.items[i].isPublish = newCompData.items[i].isPublish && canPublish(newCompData.items[i]);
    } else {
      newCompData = { ...compData, ...newData };
    }
    setCompData(newCompData);
    onUpdate(newCompData);
  }, [compData]);

  const title = (settings) => {
    return settingsData.title ? eval("`" + settingsData.title + "`") : `[${settings.listLength}/${settings.maxSize}]`;
  };

  const itemTitle = (item, settings) => {
    return `${labels.pagesManagement.videoBanner.video} ${settings.index + 1}: ${item.title} (${!canPublish(item) ? labels.pagesManagement.forms.publish_not_ready : item.isPublish ? labels.pagesManagement.forms.is_publish : labels.pagesManagement.forms.publish_ready})`;
  };

  const isEmptyItem = () => {
    return JSON.stringify(compData) === JSON.stringify(emptyItem.current)
  }

  const showRequired = (requiredField) => {
    return (!isEmptyItem() && !requiredField)
  }

  const itemContent = (item, settings) => {
    return <>
      <div className="form-field">
        <label className="form-field__label mandatory">{labels.pagesManagement.videoBanner.add_title}</label>
        <Input name={'title'} value={item.title} onChange={({ value }) => updateItem(settings.index, value, 'title')}></Input>
        {showRequired(item.title) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
      </div>
      <div className="form-field">
        <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_youtube_link}</label>
        <Input name={'video_url'} value={item.video} style={{ direction: 'ltr', textAlign: 'left' }} onChange={({ value }) => updateItem(settings.index, value, 'video')}></Input>
        <VideoPreview videoUrl={item.video} />
        {showRequired(item.video) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
      </div>
      <div className="form-field">
        <label className="form-field__label mandatory">{labels.pagesManagement.videoBanner.add_video_poster}</label>
        <Uploader type={uploaderTypes.image} imageUrl={item.video_poster} prefix={'videoBanner'} onChange={(file) => { updateItem(settings.index, { video_poster: file }) }} />
      </div>
      <div className="form-field">
        <label className="form-field__label mandatory">{labels.pagesManagement.videoBanner.add_video_poster_mobile}</label>
        <Uploader type={uploaderTypes.image} imageUrl={item.video_poster_mobile} prefix={'videoBanner'} onChange={(file) => { updateItem(settings.index, { video_poster_mobile: file }) }} />
      </div>
      <PublishSwitch isPublish={item?.isPublish} canPublish={canPublish(item)}
        updateItem={(event) => updateItem(settings.index, { isPublish: event.target.value })} />
    </>;
  };

  return <ListEditor
    isSortable={true}
    canRemove={true}
    canAdd={true}
    removeContentOnClose={false}
    maxSize={settingsData.maxSize || 10}
    minSize={settingsData.minSize || 0}
    className="videoBanner-listEditor"
    addNewItemBtnText={labels.pagesManagement.videoBanner.addNewItemBtnText}
    title={title}
    emptyItem={settingsData.type === "general" ? generalEmptyItem.current : personalEmptyItem.current}
    itemTitle={itemTitle}
    itemContent={itemContent}
    list={[...(compData.items || [])]}
    onListUpdate={(newList) => { updateItem(null, { items: newList }) }}
  />;
};